import React from 'react';

function DayRow() {
  const days = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];

  return (
    <div className="day-row">
      {days.map((day) => (
        <div className="day-cell" key={day}>
          {day}
        </div>
      ))}
    </div>
  );
}

export default DayRow;
